import React from 'react';
import styled from "styled-components";
import {ReactComponent as EmailIcon} from "assets/images/modal_email_icon.svg";
import HeaderTwo from "../customText/headers/HeaderTwo";
import {useTranslation} from "react-i18next";
import {useTypedSelector} from "hooks/useTypedRedux";
import {selectModalCheckEmail} from "redux/selectors/modalSelector";
import CustomModal from "./index";
import {updateModalCheckEmail} from "redux/reducers/appSlice";

const CheckEmailModal = () => {
    const {t} = useTranslation()
    const open = useTypedSelector(selectModalCheckEmail)
    return (
        <>
            <CustomModal open={open} updateOpen={updateModalCheckEmail}
                         styles={{borderRadius: '5px'}}>
                <Wrapper>
                    <Container>
                        <EmailIcon/>
                        <HeaderTwo color={'black'}>{t(`common.modal.email.check`)}</HeaderTwo>
                    </Container>
                </Wrapper>
            </CustomModal>
        </>
    );
};

export default CheckEmailModal;

const Wrapper = styled.div`
  width: 290px;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Container = styled.div`
  width: 220px;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * + * {
    margin-top: 25px;
  }
`